var map = {
	"./template.default": 338,
	"./template.default.tsx": 338,
	"./template.puntcity": 1572,
	"./template.puntcity.tsx": 1572,
	"./template.sterlingparker": 1573,
	"./template.sterlingparker.tsx": 1573,
	"./template.ts": 981
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2443;